import {
  GET_LOOKUP_SCREEN_OK,
  GET_LOOKUP_SCREEN_ERR,
} from "./screen-lookup.action";

const InitState = {
  error: null,
  content: null,
};

export default function LookupScreenReducer(state = InitState, action) {
  switch (action.type) {
    case GET_LOOKUP_SCREEN_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_LOOKUP_SCREEN_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
